import { ChangeDetectionStrategy, Component, HostBinding, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { AccessRightType, ApplicationSettingsType, ObjectTypes } from '@fi-shared/types';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';

@Component({
    selector: 'fi-forum-list-container',
    template: `
        <div class="fi-container">
            <div class="fi-header">
                <!--<div class="fi-header-actions">
            <fi-button-back-new></fi-button-back-new>
          </div>-->
                <div class="fi-header-text">{{ 'forum.forum_categories' | fiAppText }}</div>
                <div class="fi-header-menu">
                    @if (isMobileView) {
                        <button mat-icon-button class="" (click)="forumListComponent.toggleFilterOverlay()">
                            <mat-icon class="fas fa-filter"></mat-icon>
                        </button>
                    }
                </div>
                @if (isMenuTriggerShown()) {
                    <ng-container [ngTemplateOutlet]="FiForumListMenuTemplateRef"></ng-container>
                }
            </div>
            <div class="fi-content">
                <fi-forum-list #forumListComponent>
                    <ng-container [ngTemplateOutlet]="FiForumListMenuTemplateRef"></ng-container>
                </fi-forum-list>
            </div>
        </div>

        <ng-template #FiForumListMenuTemplateRef>
            <div class="fi-header-menu">
                <button mat-icon-button class="fi-menu-trigger-button" [matMenuTriggerFor]="forumListMenu">
                    <mat-icon class="fas fa-ellipsis-v" />
                </button>
            </div>
        </ng-template>

        <mat-menu #forumListMenu class="fi-rounded-menu">
            <button mat-menu-item class="fi-header-action-add-item" [fiStateSref]="FiStateNames.Forum.Add">
                {{ 'forum.new_forum' | fiAppText }}
            </button>
        </mat-menu>
    `,
    styleUrls: ['./fi-forum-list-container.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-forum-list-container' },
    standalone: false,
})
export class FiForumListContainerComponent implements OnInit {
    private detectDeviceService = inject(DetectDevicesService);
    private accessToApplicationTypeService = inject(AccessToApplicationTypeService);
    private pageTitleService = inject(PageTitleService);

    protected readonly isAdminRights: boolean = this.accessToApplicationTypeService.HasAccessToApplicationType(
        ApplicationSettingsType.ForumAdmin,
        AccessRightType.Read,
    );
    protected readonly FiStateNames = FiStateNames;

    @HostBinding('class.mobile-view') get isMobileView(): boolean {
        return this.detectDeviceService.isMobilePhone();
    }

    public ngOnInit(): void {
        this.pageTitleService.setTitleByItem(ObjectTypes.Forum);
    }

    protected isMenuTriggerShown(): boolean {
        return this.isMobileView && this.isAdminRights;
    }
}
